import type { EmailValue } from 'components/EmailTo'
import type { BaseFile } from 'config'

export interface INoteButton {
  label: string
  url: string
  type: 'button' | 'href'
}

export interface INote {
  id: number
  loanNumber: number
  noteBy: string
  content: string
  files: BaseFile[]
  links: INoteButton[]
  notifiers: EmailValue
  subject: string
  messageId: string | null
  history: string
  from: string
  to: string[]
  isRead: boolean
  readByReceiver: boolean
  createdAt: Date
  updatedAt: Date
}

export enum NotePageType {
  GLOBAL = 'global',
  SERVICING = 'servicing',
  REO = 'reo',
}
